var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4297 2.99996C11.4297 3.60617 11.6705 4.18755 12.0992 4.61621C12.5278 5.04486 13.1092 5.28568 13.7154 5.28568C14.3216 5.28568 14.903 5.04486 15.3316 4.61621C15.7603 4.18755 16.0011 3.60617 16.0011 2.99996C16.0011 2.39375 15.7603 1.81237 15.3316 1.38372C14.903 0.955064 14.3216 0.714249 13.7154 0.714249C13.1092 0.714249 12.5278 0.955064 12.0992 1.38372C11.6705 1.81237 11.4297 2.39375 11.4297 2.99996Z",
    fill: "#747487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71356 2.99996C5.71356 3.60617 5.95438 4.18755 6.38303 4.61621C6.81169 5.04486 7.39307 5.28568 7.99928 5.28568C8.60549 5.28568 9.18687 5.04486 9.61552 4.61621C10.0442 4.18755 10.285 3.60617 10.285 2.99996C10.285 2.39375 10.0442 1.81237 9.61552 1.38372C9.18687 0.955064 8.60549 0.714249 7.99928 0.714249C7.39307 0.714249 6.81169 0.955064 6.38303 1.38372C5.95438 1.81237 5.71356 2.39375 5.71356 2.99996Z",
    fill: "#747487"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.99999C0 3.60619 0.240816 4.18757 0.66947 4.61623C1.09812 5.04488 1.67951 5.2857 2.28571 5.2857C2.89192 5.2857 3.4733 5.04488 3.90196 4.61623C4.33061 4.18757 4.57143 3.60619 4.57143 2.99999C4.57143 2.39378 4.33061 1.8124 3.90196 1.38374C3.4733 0.955087 2.89192 0.714272 2.28571 0.714272C1.67951 0.714272 1.09812 0.955087 0.66947 1.38374C0.240816 1.8124 0 2.39378 0 2.99999H0Z",
    fill: "#747487"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalDots);
export default __webpack_public_path__ + "static/media/horizontal-dots.62672745.svg";
export { ForwardRef as ReactComponent };